import { ITableResult } from "@inode/types2";
import { Table } from "services/pilotService/responses/types";
import { Interpretation } from "@inode/pilot-client-typescript-fetch";

export function isITableResult(arg: any): arg is ITableResult {
    return arg && Array.isArray(arg.data) && Array.isArray(arg.columns);
}

export function isTable(arg: any): arg is Table {
    return arg && Array.isArray(arg.data) && Array.isArray(arg.columns);
}

export function isInterpretation(arg: any): arg is Interpretation {
    return (
        arg &&
        (arg as Interpretation).id &&
        typeof arg.id === "number" &&
        (arg as Interpretation).query &&
        typeof arg.query === "string" &&
        (arg as Interpretation).table &&
        typeof arg.table === "number" &&
        (arg as Interpretation).operatorBaseType &&
        typeof arg.operatorBaseType === "string" &&
        (arg as Interpretation).operatorSpecificType &&
        typeof arg.operatorSpecificType === "string" &&
        (arg as Interpretation).operatorInvocation &&
        typeof arg.operatorInvocation === "number"
    );
}
